import type { PosApprovalDTO } from '../dto/pos_approval.dto';
import type { PosApprovalModel } from '../../domain/models/PosApprovalModel';

export const adaptPosApprovalDtoToModel = (dto: PosApprovalDTO): PosApprovalModel => {
  return {
    phoneNumber: dto.phoneNumber,
    aplrd: dto.aplrd,
    requestedAt: dto.requestedAt,
    storeName: dto.storeName,
    expiresAt: dto.expiresAt,
    status: dto.status
  };
};